'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { SubSectionTitle } from '@/components/common/SubSectionTitle';

/**
 * Header component to display the title
 */
const HeaderLiquidation = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SubSectionTitle>Liquidations</SubSectionTitle>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(HeaderLiquidation);